import dayjs from "dayjs";
import { useState } from "react";

// TODO: Added dayjs dependency, check if these functions can be removed
function formatDate(inputString: string | null): string {
  let date;

  if (inputString === null) {
    date = new Date();
  } else {
    date = new Date(inputString);
  }

  const year = date.getFullYear();
  let month = (date.getMonth() + 1).toString();
  let day = date.getDate().toString();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  const formattedDate = `${year}-${month}-${day}`;

  return formattedDate;
}

function getDateMonthsAgo(inputString: string, monthsAgo: number) {
  const date = new Date(inputString);

  date.setMonth(date.getMonth() - monthsAgo);
  if (date.getDate() !== new Date(inputString).getDate()) {
    date.setDate(0);
  }

  const year = date.getFullYear();
  let month = (date.getMonth() + 1).toString();
  let day = date.getDate().toString();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  const formattedDate = `${year}-${month}-${day}`;

  return formattedDate;
}

function formatDateOneMonthAgoISO(
  inputString: string | null,
  monthsAgo: number
): string {
  let date;

  if (inputString === null) {
    date = new Date();
  } else {
    date = new Date(inputString);
  }

  const oneMonthAgo = date;

  // Set the month to one month ago
  oneMonthAgo?.setMonth(date?.getMonth() - monthsAgo);

  const formattedDate = oneMonthAgo?.toISOString();

  return formattedDate?.slice(0, 16);
}

function formattedDateToISOStringWithDateIncrement(dateString: string | null) {
  let date;
  if (dateString === null) {
    date = new Date();
  } else {
    date = new Date(dateString);
  }

  let day: number = date?.getDate();
  let month: number = date?.getMonth() + 1;
  const year: number = date?.getFullYear();

  const dayString: string = day < 10 ? "0" + day : day?.toString();
  const monthString: string = month < 10 ? "0" + month : month?.toString();

  const formattedDate: string = `${dayString}-${monthString}-${year}`;
  return formattedDate;
}

function formattedDateToISOStringWithMonth(dateString: string | null) {
  let date;

  if (dateString === null) {
    date = new Date();
  } else {
    date = new Date(dateString);
  }

  let day: number = date.getDate();
  let month: number = date.getMonth() + 1;
  const year: number = date.getFullYear();

  const dayString: string = day < 10 ? "0" + day : day.toString();
  const monthString: string = month < 10 ? "0" + month : month.toString();

  const formattedDate: string = `${dayString}-${monthString}-${year}`;
  const formattedDateMonth = dayjs(formattedDate, "DD-MM-YYYY");
  return formattedDateMonth.format("DD-MM-YYYY");
}

const formatDateAlongWithTime = (inputDate: string | null) => {
  //10-July-2024 12:00 PM
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  let dateObj;

  if (inputDate === null) {
    dateObj = new Date();
  } else {
    dateObj = new Date(inputDate);
  }
  const day = dateObj.getDate();
  const monthIndex = dateObj.getMonth();
  const year = String(dateObj.getFullYear()).slice(-2);
  let hours = dateObj.getHours();
  let minutes = dateObj.getMinutes();
  let period = "AM";

  // Convert hours to AM/PM format
  if (hours >= 12) {
    period = "PM";
    if (hours > 12) {
      hours -= 12;
    }
  }
  if (hours === 0) {
    hours = 12; // 0 hour should be represented as 12 in AM/PM format
  }

  // Add leading zeros if necessary
  const formattedDay = (day < 10 ? "0" : "") + day;
  const formattedMonth = months[monthIndex];
  const formattedYear = (parseInt(year) < 10 ? "0" : "") + year;
  const formattedHours = (hours < 10 ? "0" : "") + hours;
  const formattedMinutes = (minutes < 10 ? "0" : "") + minutes;

  return `${formattedDay}-${formattedMonth}-${formattedYear} ${formattedHours}:${formattedMinutes} ${period}`;
};

const formatDateWithoutTime = (inputDate: string | null) => {
  //10-July-2024 12:00 PM
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  let dateObj;

  if (inputDate === null) {
    dateObj = new Date();
  } else {
    dateObj = new Date(inputDate);
  }
  const day = dateObj.getDate();
  const monthIndex = dateObj.getMonth();
  const year = String(dateObj.getFullYear()).slice(-2);
  let hours = dateObj.getHours();
  let minutes = dateObj.getMinutes();
  let period = "AM";

  // Convert hours to AM/PM format
  if (hours >= 12) {
    period = "PM";
    if (hours > 12) {
      hours -= 12;
    }
  }
  if (hours === 0) {
    hours = 12; // 0 hour should be represented as 12 in AM/PM format
  }

  // Add leading zeros if necessary
  const formattedDay = (day < 10 ? "0" : "") + day;
  const formattedMonth = months[monthIndex];
  const formattedYear = (parseInt(year) < 10 ? "0" : "") + year;

  return `${formattedDay}-${formattedMonth}-${formattedYear}`;
};

function dispatchAppEvent(eventName: string, data?: object) {
  const event = new CustomEvent(eventName, {
    detail: data,
  });
  window.dispatchEvent(event);
}

const formatDateTime = (dateTimeStr: string) => {
  //2024-07-11T07:31:01.000Z" "1:01:01 PM -> hh:mm:ssA
  const date = new Date(dateTimeStr);

  let hours = date.getUTCHours();
  const minutes = date.getUTCMinutes();
  const seconds = date.getUTCSeconds();

  const ampm = hours >= 12 ? "PM" : "AM";

  hours = hours % 12;
  hours = hours ? hours : 12;

  const formattedHours = hours.toString().padStart(2, "0");
  const formattedMinutes = minutes.toString().padStart(2, "0");
  const formattedSeconds = seconds.toString().padStart(2, "0");

  // Return the formatted time string
  return `${formattedHours}:${formattedMinutes}:${formattedSeconds}${ampm}`;
};

function calculateAge(dob: string): number {
  const birthDate = dayjs(dob, "DD-MM-YYYY");
  const today = dayjs();

  let age = today.year() - birthDate.year();

  if (
    today.month() < birthDate.month() ||
    (today.month() === birthDate.month() && today.date() < birthDate.date())
  ) {
    age--;
  }

  return age;
}
const formatDates = (datetime: string) => {
  if (!datetime) {
    return " ";
  }

  const format = datetime.length > 10 ? "DD-MM-YYYY HH:mm:ss" : "DD-MM-YYYY";
  return dayjs(datetime, format).format("DD-MM-YYYY");
};
const formatDatesWithTime = (datetime: string) => {
  if (!datetime) {
    return " ";
  }

  const format = datetime.length > 10 ? "DD-MM-YYYY HH:mm:ss" : "DD-MM-YYYY";
  return dayjs(datetime, format).format("DD-MM-YYYY HH:mm:ss");
};

const formattedDateWithTime = (input: string) => {
  const [datePart, timePart] = input.split(" ");
  const [day, month, year] = datePart.split("-");
  const [hours, minutes] = timePart.split(":");

  const date = new Date(`${year}-${month}-${day}T${hours}:${minutes}`);

  // Format the output
  const formattedDate = `${day}-${month}-${year} ${date
    .toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    })
    .replace(" ", "")}`;

    return formattedDate;
};

const formattedDateWithTimeUstToIst = (input: string) => {
  const [datePart, timePart] = input.split(" ");
  const [day, month, year] = datePart.split("-");
  const [hours, minutes] = timePart.split(":");

  // Create date in UTC
  const date = new Date(`${year}-${month}-${day}T${hours}:${minutes}:00Z`);

  // Convert to IST using toLocaleString with 'Asia/Kolkata'
  const options: Intl.DateTimeFormatOptions = {
    timeZone: "Asia/Kolkata",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  };

  const istDate = new Date(date.toLocaleString("en-US", { timeZone: "Asia/Kolkata" }));
  const formattedTime = date.toLocaleTimeString("en-US", options).replace(" ", "");

  const istDay = istDate.getDate().toString().padStart(2, '0');
  const istMonth = (istDate.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-based
  const istYear = istDate.getFullYear();

  return `${istDay}-${istMonth}-${istYear} ${formattedTime}`;
};


const convertIdToTitleCase = (input: string) => {
  return input
    .split("-")
    ?.map((word) => word.toUpperCase())
    .join(" ");
};

const extractFileType = (
  input: string | null
):
  | "pdf"
  | "jpeg"
  | "jpg"
  | "png"
  | "xlsx"
  | "react-component"
  | "application/pdf"
  | "image/jpeg"
  | "image/jpg"
  | "image/png"
  | "xls"
  | "unsupported" => {
  if (input === null) {
    return "unsupported";
  }
  const decodedUrl = decodeURIComponent(input);
  const fileType = decodedUrl.substring(decodedUrl.lastIndexOf(".") + 1);

  switch (fileType) {
    case "pdf":
      return "pdf";
    case "jpeg":
      return "jpeg";
    case "jpg":
      return "jpg";
    case "png":
      return "png";
    case "xls":
      return "xls";
    case "react-component":
      return "react-component";
    case "application/pdf":
      return "application/pdf";
    case "image/jpeg":
      return "image/jpeg";
    case "image/jpg":
      return "image/jpg";
    case "image/png":
      return "image/png";
    default:
      return "unsupported";
  }
};

const convertStringToCamelCase = (str: string) => {
  if (!str) {
    return "";
  }
  return str
    .replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
      return index == 0 ? word.toLowerCase() : word.toUpperCase();
    })
    .replace(/\s+/g, "");
};

const useDebounceSearch = (
  callback: (value: string) => void,
  delay: number = 500
) => {
  const [debounceTimeout, setDebounceTimeout] = useState<NodeJS.Timeout | null>(
    null
  );

  const onSearchChange = (value: string) => {
    if (debounceTimeout) {
      clearTimeout(debounceTimeout); // Clear the previous timeout
    }

    const timeout = setTimeout(() => {
      callback(value); // Call the passed callback (handleSearchNameChange)
    }, delay);

    setDebounceTimeout(timeout); // Store the timeout ID
  };

  return { onSearchChange };
};

export {
  convertStringToCamelCase,
  extractFileType,
  convertIdToTitleCase,
  formatDate,
  getDateMonthsAgo,
  formatDateOneMonthAgoISO,
  formattedDateToISOStringWithDateIncrement,
  dispatchAppEvent,
  formatDateAlongWithTime,
  formatDateWithoutTime,
  formattedDateToISOStringWithMonth,
  formatDateTime,
  calculateAge,
  formatDates,
  formatDatesWithTime,
  useDebounceSearch,
  formattedDateWithTime,
  formattedDateWithTimeUstToIst
};
